import {
  CANDIDATE_PROFILE_DETAILS_REQUEST,
  CANDIDATE_PROFILE_DETAILS_FAIL,
  CANDIDATE_PROFILE_DETAILS_SUCCESS
} from "../constants/AuthConstant";

import axios from "axios";

const baseUrl = process.env.REACT_APP_API_PATH;

// ------------------------------
// Load Success Action
// ------------------------------
export const loadAllDetailsPre = (data) => ({
  type: CANDIDATE_PROFILE_DETAILS_SUCCESS,
  result: data,
  payload: false,
  loading: false,
  msg: "SUCCESS",
});

// ------------------------------
// Candidate Profile Action
// ------------------------------
export const CandidateProfile = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CANDIDATE_PROFILE_DETAILS_REQUEST,
      payload: true,
    });

    try {
      const res = await axios.get(`${baseUrl}/ebench/get_Candidate`, {
        params: { id },
        headers: {
          "content-type": "application/json",
        },
      });

      // Dispatch redux success
      dispatch(loadAllDetailsPre(res.data));

      // Save Team Member info locally
      const isTeamMember = res?.data?.data?.isTeamMember;
      localStorage.setItem("isTeamMember", isTeamMember);

      return Promise.resolve(res.data); 
    } catch (error) {
      dispatch({
        type: CANDIDATE_PROFILE_DETAILS_FAIL,
        payload: false,
        error,
        msg: "Failed to load the information",
      });

      return Promise.reject(error); 
    }
  };
};
